<template>
  <div class="detail">
    <div class="img-con-banner" @click="showBanner(bannerList, 0)">
      <swiper v-if="bannerList && bannerList.length" :list="bannerList" />
      <div
        :class="[
          'top-icon',
          detail.status == 1
            ? 'bg-1'
            : detail.status == 2
            ? 'bg-2'
            : detail.status == 3
            ? 'bg-3'
            : 'bg-4',
        ]"
      ></div>
    </div>
    <!-- status 1:处理中 2:已反馈 3.不合格 4.已完成 -->
    <div class="line">基础描述</div>
    <div class="foot">
      <div class="item">
        <div class="v1 point-title">督查点位：</div>
        <div class="v1">
          {{ detail.point_name }}
        </div>
      </div>
      <div class="item">
        <div class="v1">考察内容：</div>
        <div class="v1">
          {{ detail.cate_name }}
        </div>
      </div>
      <div class="item">
        <div class="v1">详细地址：</div>
        <div class="address">
          {{ detail.address }}
        </div>
      </div>
      <div class="item">
        <div class="v1">责任部门：</div>
        <div class="v1">
          {{ detail.area_name }}
        </div>
      </div>
      <div class="item">
        <div>接单时间：</div>
        <div>
          {{ detail.add_time_text }}
        </div>
      </div>
      <div class="item">
        <div class="v1">整改期限：</div>
        <div class="v1">
          {{ detail.expire_time_text }}
        </div>
      </div>
      <div class="item-content">
        <div class="v1">整改建议：</div>
        <div>
          {{ detail.suggestion }}
        </div>
      </div>
      <div class="item-content">
        <div class="v1">事件描述：</div>
        <div>
          <!-- <textarea v-model="detail.content" readonly></textarea> -->
          {{ detail.content }}
        </div>
      </div>
    </div>
    <!-- <div class="line">事件描述</div> -->
    <div class="body" v-if="detail.finish_time_text">
      <div class="item" v-if="detail.finish_time_text">
        <div>完成时间：</div>
        <div>
          {{ detail.finish_time_text }}
        </div>
      </div>
      <div class="item-content" v-if="detail.chargeback_reason">
        <div>退单理由：</div>
        <div>
          <textarea v-model="detail.chargeback_reason" readonly></textarea>
        </div>
      </div>
      <div class="item-content" v-if="detail.rejection_reason">
        <div>拒退理由：</div>
        <div>
          <textarea v-model="detail.rejection_reason" readonly></textarea>
        </div>
      </div>
      <div class="item-content-el" v-if="detail.processing_describe_1">
        <div class="v1">第一次处理描述：</div>
        <div class="v2">
          <textarea v-model="detail.processing_describe_1" readonly></textarea>
        </div>
        <img
          style="width: 1.44rem; height: 1.44rem; margin-top: 0.14rem"
          :src="$IMG_PATH + item"
          alt=""
          @click="showImg(detail.feedback_img_1, index)"
          v-for="(item, index) in detail.feedback_img_1"
          :key="index"
        />
      </div>

      <div class="item-content" v-if="detail.unqualified_reason_1">
        <div>一次不合格理由：</div>
        <div>
          <textarea v-model="detail.unqualified_reason_1" readonly></textarea>
        </div>
      </div>

      <div class="item-content-el" v-if="detail.processing_describe_2">
        <div class="v1">第二次处理描述：</div>
        <div class="v2">
          <textarea v-model="detail.processing_describe_2" readonly></textarea>
        </div>
        <img
          style="width: 1.44rem; height: 1.44rem; margin-top: 0.14rem"
          :src="$IMG_PATH + item"
          alt=""
          @click="showImg(detail.feedback_img_2, index)"
          v-for="(item, index) in detail.feedback_img_2"
          :key="index"
        />
      </div>
      <div class="item-content" v-if="detail.unqualified_reason_2">
        <div>二次不合格理由：</div>
        <div>
          <textarea v-model="detail.unqualified_reason_2" readonly></textarea>
        </div>
      </div>
    </div>
    <div class="line" v-if="detail.finish_reason">完成描述</div>
    <div class="body" v-if="detail.finish_reason">
      <div class="item-content">
        <div>结案理由：</div>
        <div>
          <textarea v-model="detail.finish_reason" readonly></textarea>
        </div>
      </div>
    </div>
    <div class="btns">
      <div
        class="v1"
        v-if="detail.status == 1 && detail.is_back !== 1"
        @click="showFinish = true"
      >
        结案
      </div>
      <div
        class="v1"
        v-if="detail.status == 1 && detail.is_back == 1"
        @click="showone = true"
      >
        拒退
      </div>
      <div
        class="v1"
        v-if="detail.status == 2 && detail.unqualified_reason_1 == ''"
        @click="showtwo = true"
      >
        一次不合格
      </div>
      <div
        class="v1"
        v-if="detail.status == 2 && detail.unqualified_reason_1 !== ''"
        @click="showtree = true"
      >
        二次不合格
      </div>
      <div
        class="v2"
        v-if="detail.status == 1 && detail.is_back == 1"
        @click="showAssign"
      >
        重新指派
      </div>
      <div
        class="v2"
        v-if="detail.status == 2 || detail.status == 3"
        @click="showFinish = true"
      >
        结案
      </div>
    </div>
    <van-dialog
      v-model="showone"
      title="拒退理由"
      show-cancel-button
      @confirm="subDel(3)"
    >
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="showtwo"
      title="一次不合格理由"
      show-cancel-button
      @confirm="subDel(4)"
    >
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="showtree"
      title="二次不合格理由"
      show-cancel-button
      @confirm="subDel(6)"
    >
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="showFinish"
      title="结案理由"
      show-cancel-button
      @confirm="subDel2"
    >
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入结案理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="assignShow"
      title="重新指派"
      show-cancel-button
      @confirm="assignTo"
      :before-close="beforeClose"
    >
      <div class="all">
        <div class="item-all" @click="branchShow = true">
          <span>{{ branch ? branch : "请选择责任部门" }}</span>
          <img src="@/assets/images/report/choose.png" alt="" class="img-con" />
        </div>
        <div class="item-all" @click="show = true">
          <!-- <input
            type="Number"
            v-model="days"
            placeholder="可输入新的整改期限"
          />
          <div @click="unitShow = true">
            <span>{{ unit }}</span>
            <img
              src="@/assets/images/report/choose.png"
              alt=""
              class="img-con"
            />
          </div> -->
          <span>{{ time ? time : "请选择整改期限" }}</span>
          <img src="@/assets/images/report/choose.png" alt="" class="img-con" />
        </div>
        <div class="item-all suggestion">
          <div class="title">整改建议</div>
          <div>
            <textarea
              placeholder="请简单描述..."
              v-model="suggestion"
            ></textarea>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="branchShow" round position="bottom">
      <van-picker
        title="选择责任部门"
        show-toolbar
        :columns="columns"
        @confirm="getBranch"
        @cancel="branchShow = false"
      />
    </van-popup>
    <!-- 整改期限（弃用） -->
    <!-- <van-popup v-model="daysShow" round position="bottom">
      <van-picker
        title="选择新增天数"
        show-toolbar
        :columns="daysColumns"
        @confirm="getDays"
        @cancel="daysShow = false"
      />
    </van-popup> -->

    <!-- 整改期限 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="settime"
      />
    </van-popup>
    <van-action-sheet
      v-model="unitShow"
      :actions="unitAction"
      cancel-text="取消"
      description="选择时间单位"
      close-on-click-action
      @select="getUnit"
    />
  </div>
</template>

<script>
import Swiper from "@/components/Swiper";
import upload from "@/components/Upload";
import {
  getMyEventDetail,
  changeWork,
  getAreaList,
  assignNew,
  getDepartmentList,
} from "../api";
import { Dialog } from "vant";
import { Toast } from "vant";
import { ImagePreview } from "vant";
export default {
  components: {
    Swiper,
    [Dialog.Component.name]: Dialog.Component,
    upload,
  },
  data() {
    return {
      bannerList: [],
      showone: false,
      showtwo: false,
      showtree: false,
      assignShow: false,
      branch: "",
      branch_id: "",
      branchShow: false,
      unitAction: [
        { type: "1", name: "天" },
        { type: "2", name: "小时" },
      ],
      unit: "天",
      unitType: 1,
      unitShow: false,
      days: "",
      daysShow: false,
      daysColumns: [0, 2, 4, 6, 8],
      columns: [],
      columnsId: [],
      message: "",
      imgList: [],
      detail: {},
      showFinish: false,
      show: false,
      time: this.filterTime(new Date()),
      minDate: new Date(),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      suggestion: "",
    };
  },
  created() {
    let id = this.$route.params.id;
    this.init(id);
  },
  methods: {
    filterTime(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      // return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
      return y + "-" + m + "-" + d;
    },
    settime(val) {
      this.show = false;
      this.time = this.getTime(val);
      console.log("选中的时间", this.time);
    },
    getTime(data) {
      let month = Number(data.getMonth()) + 1;
      let day = data.getDate();
      return (
        data.getFullYear().toString() +
        "-" +
        (month > 10 ? month : "0" + month) +
        "-" +
        (day > 10 ? day : "0" + day)
      );
    },
    init(id) {
      let params = {
        id: id,
      };
      getMyEventDetail(params).then((res) => {
        console.log("res", res);
        this.detail = res.data;
        this.bannerList = this.detail.img.map((e) => {
          return this.$IMG_PATH + e;
        });
      });
    },
    getUnit(action) {
      this.unit = action.name;
      this.unitType = action.type;
    },
    // 指派选择弹窗
    showAssign() {
      this.assignShow = true;
      this.initCol();
    },
    // 选择责任部门
    getBranch(value, index) {
      this.branchShow = false;
      this.branch = value;
      this.branch_id = this.columnsId[index];
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.branch_id) {
          done();
        } else {
          done(false);
          Toast.fail("请先选择责任部门");
        }
      } else {
        done();
      }
    },
    // 重新指派
    assignTo() {
      if (!this.branch_id) {
        return;
      }
      let params = {
        id: this.detail.id,
        area_id: this.branch_id,
        timelimit: this.time,
        suggestion: this.suggestion,
        // timelimit: this.days,
        // timelimitunit: this.unitType,
      };
      assignNew(params).then((res) => {
        if (res.code == 0) {
          Toast.success("指派成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          Toast.fail(res.message);
        }
      });
    },
    subDel2() {
      if (!this.message) {
        Toast.fail("请输入理由");
      } else {
        let that = this;
        this.showFinish = false;
        Toast.loading("提交中");
        let params = {
          type: 5,
          id: this.detail.id,
          content: this.message,
          token: window.localStorage.getItem("token"),
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("提交成功");
            setTimeout(() => {
              that.$router.go(0);
            }, 1200);
          }
          this.message = "";
        });
      }
    },
    getDays(value, index) {
      this.daysShow = false;
      this.days = value;
    },
    initCol() {
      let params = {
        id: this.detail.category_id,
      };
      getDepartmentList(params).then((res) => {
        this.columns = res.data.department.map((e) => {
          return e.name;
        });
        this.columnsId = res.data.department.map((e) => {
          return e.id;
        });
      });
    },
    showImg(imgList, index) {
      let imgs = [];
      imgList.forEach((item) => {
        imgs.push(this.$IMG_PATH + item);
      });
      this.instance_show = ImagePreview({
        images: imgs,
        startPosition: index,
      });
    },
    showBanner(imgList, index) {
      this.instance_show = ImagePreview({
        images: imgList,
        startPosition: index,
      });
    },
    finish(type) {
      this.showtree = false;
      Toast.loading("提交中");
      let params = {
        type: type,
        id: this.detail.id,
        token: window.localStorage.getItem("token"),
      };
      changeWork(params).then((res) => {
        if (res.code == 0) {
          Toast.success("提交成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1200);
        }
        this.message = "";
      });
    },
    subDel(type) {
      if (!this.message) {
        Toast.fail("请输入理由");
      } else {
        let that = this;
        this.showone = false;
        Toast.loading("提交中");
        let params = {
          type: type,
          id: this.detail.id,
          content: this.message,
          token: window.localStorage.getItem("token"),
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("提交成功");
            setTimeout(() => {
              that.$router.go(-1);
            }, 1200);
          }
          this.message = "";
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0.24rem 0.3rem 0.54rem;
  overflow: hidden;
  .img-con-banner {
    width: 100%;
    height: 3.9rem;
    overflow: hidden;
    margin-bottom: 0.24rem;
    position: relative;
    /deep/.swiper {
      width: 100%;
      height: 3.9rem !important;
      overflow: hidden;
    }
    /deep/ img {
      width: 100%;
      height: 3.9rem !important;
      display: block;
      border-radius: 0.08rem;
    }
    .top-icon {
      width: 1.4rem;
      height: 0.72rem;
      position: absolute;
      top: 8%;
      right: 0;
    }
    .bg-1 {
      background-image: url("../../../assets/images/mine/3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-2 {
      background-image: url("../../../assets/images/mine/5.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-3 {
      background-image: url("../../../assets/images/mine/8.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-4 {
      background-image: url("../../../assets/images/mine/9.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .body {
    width: 100%;
    min-height: 1rem;
    background-color: #fff;
    border-radius: 0.14rem;
    margin-top: 0.3rem;
    padding: 0 0.2rem 0.2rem;
    > div:last-child {
      border: none;
    }
    .item {
      height: 0.9rem;
      display: flex;
      line-height: 0.9rem;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 2rem;
      }
      > div:last-child {
        width: calc(100% - 2rem);
        color: #999;
      }
    }
    .item-content {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        min-height: 1.4rem;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: none;
        }
      }
    }
    .item-content-el {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      .v1 {
        min-width: 2rem;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      .v2 {
        width: 100%;
        min-height: 1.4rem;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: none;
        }
      }
    }
  }
  .line {
    width: 100%;
    height: 0.4rem;
    padding-left: 0.14rem;
    border-left: 0.14rem solid #1883fe;
    margin-top: 0.2rem;
  }
  .foot {
    width: 100%;
    min-height: 6rem;
    background-color: #fff;
    border-radius: 0.14rem;
    margin-top: 0.3rem;
    padding: 0 0.2rem;
    padding-bottom: 10px;
    margin-bottom: 10px;
    > div:first-child {
      > div:last-child {
        // max-width: 3rem;
        // height: 0.6rem;
        margin-top: 0.13rem;
        margin-bottom: 0.13rem;
        // line-height: 0.6rem;
        // text-align: center;
        color: #999;
        // font-size: 0.26rem;
        border-radius: 0.1rem;
        // background-color: #fda143;
      }
    }
    > div:last-child {
      border: none;
    }
    .item {
      display: flex;
      min-height: 0.9rem;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      display: flex;
      align-items: center;
      > div:first-child {
        width: 1.5rem;
      }
      > div:last-child {
        margin: 5px auto;
        width: calc(100% - 2rem);
        color: #999;
      }
      // .point-title {
      //   text-justify: distribute-all-lines;
      //   text-align: justify;
      //   text-align-last: justify;
      // }
    }
    .item-content {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 2rem;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        min-height: 1rem;
        padding: 10px;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        textarea {
          width: 100%;
          min-height: 2rem;
          padding: 0.1rem;
          border: none;
        }
      }
    }
    .item-content-m {
      width: 100%;
      > div:first-child {
        width: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        height: 1.4rem;
        color: #999;
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: 1px solid rgba(112, 112, 112, 0.1);
        }
      }
    }
  }
  .btns {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    color: #fff;
    text-align: center;
    font-size: 0.32rem;
    display: flex;
    > div {
      flex: 1;
      height: 100%;
    }
    .v1 {
      background-image: linear-gradient(to right, #fc9227, #febe76);
    }
    .v2 {
      background-image: linear-gradient(to right, #277cfc, #4dacff);
    }
  }
  .all {
    width: 100%;
    min-height: 0.84rem;
    margin-bottom: 0.2rem;
    .item-all {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 0.84rem;
      border: 0px solid rgba(225, 225, 225, 1);
      border-radius: 0.15rem;
      color: #333;
      background: rgba(245, 245, 245, 1);
      border: 0px solid rgba(225, 225, 225, 1);
      border-radius: 4px;
      color: #666666;
      font-size: 14px;
      padding: 0 0.3rem;
      margin-top: 0.2rem;
      .img-con {
        width: 0.3rem;
        height: 0.3rem;
      }
      div {
        width: 1rem;
        height: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      input {
        width: 100%;
        height: 0.84rem;
        background-color: #f5f5f5;
        border: none;
      }
    }
    .suggestion {
      flex-direction: column;
      align-items: flex-start;
      .title {
        // margin: 10px 0;
        white-space: nowrap;
        // margin-bottom: 40px;
        width: auto;
        height: auto;
      }
      > div:nth-child(2) {
        width: 100%;
        height: 2rem;
        // overflow: hidden;
      }
      textarea {
        width: 100%;
        height: 100%;
        border: 0.02rem solid rgba(225, 225, 225, 1);
        border-radius: 6px;
        padding: 10px;
        background: rgba(244, 246, 248, 1);
        resize: none;
      }
      textarea::-webkit-input-placeholder {
        color: #969799;
      }
    }
  }
}
</style>